var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useShopConfig } from '@jetshop/core/hooks/useShopConfig';
import Image from './BaseImage';
import React from 'react';
import t from '@jetshop/intl';
import { useConstructImage } from './useConstructImage';
import ChannelContext from '@jetshop/core/components/ChannelContext';
export const transparentDataImg = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
function Error() {
    return (React.createElement("div", { style: {
            background: '#e2e2e2',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: `absolute`,
            top: 0,
            left: 0,
            width: `100%`,
            height: `100%`
        } }, t('Image Not Found')));
}
function FlightImage(props) {
    const { gravity, crop, src: originalSrc, sizes: sizesArray = [1], aspect, quality, critical, modifiedDate, error: ErrorComp = Error } = props, rest = __rest(props, ["gravity", "crop", "src", "sizes", "aspect", "quality", "critical", "modifiedDate", "error"]);
    const { theme: { breakpoints } } = useShopConfig();
    // The baseUrl will change based on the currently-selected channel.
    // We need it to correctly construct the image url
    const { selectedChannel } = React.useContext(ChannelContext);
    const baseUrl = (selectedChannel === null || selectedChannel === void 0 ? void 0 : selectedChannel.imageUrl)
        ? String(selectedChannel.imageUrl)
        : null;
    const { src, hasFalsySrc, lqip, sizes, srcset, webpSrcset } = useConstructImage({
        gravity,
        crop,
        src: originalSrc,
        sizes: sizesArray,
        aspect,
        quality,
        critical,
        modifiedDate,
        breakpoints,
        baseUrl
    });
    return (React.createElement(Image, Object.assign({}, rest, { critical: critical, aspect: aspect, src: hasFalsySrc && typeof originalSrc === 'boolean' ? false : src, hasFalsySrc: hasFalsySrc, lqip: lqip, sizes: sizes, srcset: srcset, webpSrcset: webpSrcset, error: ErrorComp })));
}
export default FlightImage;
//# sourceMappingURL=FlightImage.js.map